"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const constants_1 = require("@framework/constants");
const provider_settings_1 = require("@framework/provider-settings");
const Theme = () => {
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const settings = (0, provider_settings_1.useSettings)();
    const handleThemeIconClick = () => {
        settings.setTheme(settings.getTheme() === constants_1.ThemeType.light ? constants_1.ThemeType.dark : constants_1.ThemeType.light);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: formatMessage({ id: "components.header.theme.switch" }), children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { color: "inherit", onClick: handleThemeIconClick, "data-testid": "switchTheme", children: settings.getTheme() === constants_1.ThemeType.light ? (0, jsx_runtime_1.jsx)(icons_material_1.Brightness4, {}) : (0, jsx_runtime_1.jsx)(icons_material_1.Brightness7, {}) }) }));
};
exports.Theme = Theme;
//# sourceMappingURL=index.js.map